export default __webpack_public_path__ + "static/media/image.360-labs.279c2765.png";